"use client";

export { ErrorPage as default } from "~/components/error-pages/error-page-eon";
